import BaseValidator from 'services/validations/base-validator';
import {getUnique, getPropValues} from 'helpers/array-helper';

class MinTeamsValidator extends BaseValidator {
    private minTeams: number = 0;
    private ignoredPlayerPositions: number[] = [];

    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        this.minTeams = sportConfig.getConfigProp('minTeams', 0);
        this.ignoredPlayerPositions = sportConfig.getConfigProp('ignoredPositionsForMinTeamsValidation', []);

        if (this.isTeamsQuantityEnough()) {
            return;
        }

        this.addError(`A minimum of ${this.minTeams} teams needed.`);
    }

    private isTeamsQuantityEnough(): boolean {
        // @ts-ignore
        const {sportConfig} = this.dependencies;

        const uniqueTeamsQuantity = this.calcUniqueTeamsQuantity();

        return this.minTeams <= uniqueTeamsQuantity;
    }

    private calcUniqueTeamsQuantity(): number {
        // @ts-ignore
        let {playersDividedByPosition} = this.dependencies;

        const players = isEmpty(this.ignoredPlayerPositions)
            ? playersDividedByPosition
            : playersDividedByPosition.filter((player) => !inArray(player.getId(), this.ignoredPlayerPositions));

        const teams = getPropValues(players, 'team');

        return getUnique(teams).length;
    }
}

export {MinTeamsValidator};
